import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin'
import {
  authenticateCreate,
  authenticatePasswordConfirm,
  authResource,
} from '@/services/auth.service'
import useDeviceInfo from '@/composables/useDevice'
import { storage } from '@/utils/session'
import {
  HQ_VPN_ACCESS_TOKEN_STORAGE_NAME,
  HQ_VPN_REFRESH_TOKEN_STORAGE_NAME,
  HQ_VPN_IS_AUTH_STORAGE_NAME,
} from '@/const'
import useGlobal from '../../composables/useGlobal'
import MailChecker from 'mailchecker'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForm',
  props: ['cabinetLink', 'testLink', 'subscriptionsLink', 'passResetLink'],
  setup(__props, { expose }) {
  expose();

const props = __props


const { $t } = useGlobal()

const authId = ref("")
const load: Ref<boolean> = ref(false)
const activeTimer = ref(false)
const email = ref("")
const password = ref("")
const emailError = ref($t('Не подходящий email'))
const timeIsOver = ref(false)

const request = (sendData: any, control: any) => {
  if(MailChecker.isValid(email.value)) {
    useSubmit(send(sendData, control), control)
  } else {
    control.setFieldError('email', emailError.value)
  }
}


const tokenId: Ref<string> = ref('')
const twoFactorId: Ref<string> = ref('')
//  exemple@gmail.com
const send = async (sendData, control) => {
  load.value = true
  const preparedData = {
    email: email.value,
    password: password.value
  }
  try {
    load.value = false
    const { data: { access, refresh } } = (await authenticatePasswordConfirm.execute({ type: 'client' }, {
      ...useDeviceInfo(),
      credentials: {
       ...preparedData
      },
    }))
    storage.setItem(HQ_VPN_ACCESS_TOKEN_STORAGE_NAME, access)
    storage.setItem(HQ_VPN_REFRESH_TOKEN_STORAGE_NAME, refresh)
    storage.setItem(HQ_VPN_IS_AUTH_STORAGE_NAME, access)
    //fixme
    window.location.href = props.cabinetLink
  } catch(e) {
      e.json().then(body => {
        console.log("🚀 ~ file: AuthForm.vue:132 ~ e.json ~ body:", body)
        control.setFieldError('email', body.errors[0].state.credentials.state.non_field_errors[0].message)
        Object.keys(body).forEach(key => {
          control.setFieldError(key, body[key][0])
        })
      })
      load.value = false
      // return Promise.reject(e)
  }
}


const __returned__ = { props, $t, authId, load, activeTimer, email, password, emailError, timeIsOver, request, tokenId, twoFactorId, send, ref, useSubmit, authenticateCreate, authenticatePasswordConfirm, authResource, useDeviceInfo, storage, HQ_VPN_ACCESS_TOKEN_STORAGE_NAME, HQ_VPN_REFRESH_TOKEN_STORAGE_NAME, HQ_VPN_IS_AUTH_STORAGE_NAME, useGlobal, MailChecker }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})